<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in deliveryRecordTabs"
          :key="index"
        >
          <el-form class="search-style">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item>
                  <el-select v-model="params.column">
                    <el-option
                      v-for="(item, index) in contractScreenCondition"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="params.column === 'deliverState'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="物流在途" :value="1"></el-option>
                    <el-option label="验收" :value="2"></el-option>
                    <el-option label="已入库" :value="3"></el-option>
                    <el-option label="已作废" :value="4"></el-option>
                    <el-option label="已发货" :value="5"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="params.column !== 'deliverState'">
                <el-form-item >
                  <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button @click="search" type="primary">搜索</el-button>
                  <el-button @click="resetSearch" type>重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="box-table" :style="{height: tableHeight+'px'}">
            <el-table
              border
              ref="tableRef"
              :data="list"
              :max-height="tableHeight"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column prop="deliverNumber" show-overflow-tooltip label="发货编号">
                <template slot-scope="scope">
                  <div @click="shipmentDetails(scope.row)" class="approval line-limit-length">
                    {{
                    scope.row.deliverNumber
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="code" show-overflow-tooltip label="合同编号">
                <template slot-scope="scope">
                  <div @click="contractDetails(scope.row)" class="approval line-limit-length">
                    {{
                    scope.row.pcbNumber
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="supplierContractNumber" show-overflow-tooltip label="供应商合同编号"></el-table-column>
              <el-table-column prop="suName" show-overflow-tooltip label="供应商名称">
                <template slot-scope="scope">
                  <div
                    @click="onSuName(scope.row)"
                    class="approval line-limit-length"
                  >{{scope.row.suName}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="deliverType" show-overflow-tooltip label="发货方式"></el-table-column>
              <el-table-column prop="deliveryInfo" show-overflow-tooltip label="发货信息"></el-table-column>
              <el-table-column label="请求发货时间" show-overflow-tooltip prop="createDate">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.createDate | dateFilter }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="deliverState" show-overflow-tooltip label="发货状态">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ status[scope.row.deliverState - 1] }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="warehouseDate" show-overflow-tooltip label="入库时间">
                <template slot-scope="scope">
                  <div class="line-limit-length">{{ scope.row.warehouseDate | dateFilter }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { queryPageAll } from '@/api/purchase/purchasePlanList'
import { formatDate } from '@/util/tool'
import { deepClone } from '@/util'

import { deliveryRecordTabs } from './util/data'
export default {
  components: {
    pagination: pagination
  },
  data() {
    return {
      status: ['物流在途', '验收', '已入库', '已作废', '已发货'],
      state: ['待审核', '审核中', '履行中', '已履行', '待签署'],
      deliverState: 0,
      activeName: '全部', // tabs选中状态
      deliveryRecordTabs: deliveryRecordTabs, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      queryParams: {}, // 搜索条件
      params: {
        column: 'suName'
      },
      paramsList: {},
      contractScreenCondition: [
        { label: '发货编号', value: 'deliverNumber' },
        { label: '合同编号', value: 'pcbNumber' },
        { label: '供应商合同编号', value: 'supplierContractNumber' },
        { label: '供应商名称', value: 'suName' },
        { label: '发货方式', value: 'deliverType' },
        { label: '发货信息', value: 'deliveryInfo' },
        { label: '发货状态', value: 'deliverState' }
      ], // 筛选条件
      expressionList: expressionList,
      tableHeight: window.innerHeight - 380
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 发货编号
    shipmentDetails(row) {
      this.$router.push({
        name: 'shipmentDetails',
        query: { pcbId: row.pcbId, deliverNumber: row.deliverNumber }
      })
    },
    // 发货编号
    contractDetails(row) {
      const state = this.state[row.contractState - 1]
      this.$router.push({
        name: 'contractDetails',
        query: { type: state, pcbId: row.pcbId }
      })
    },
    // 搜索
    search() {
      this.paramsList = deepClone(this.params)
      if (
        this.paramsList.value === '' ||
        this.paramsList.value === undefined ||
        this.paramsList.column === undefined
      ) {
        // this.getList()
        this.$message.error('搜索条件不能为空')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    resetSearch() {
      this.params = {
        column: 'suName'
      }
      this.time = []
      this.paramsList = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // tabs切换时触发的事件
    handleClick(activeName) {
      this.currentPage = 1
      if (activeName === '全部') {
        this.deliverState = 0
      } else if (activeName === '已发货') {
        this.deliverState = 1
      } else if (activeName === '物流在途') {
        this.deliverState = 2
      } else if (activeName === '已入库') {
        this.deliverState = 3
      }
      this.params = {
        column: 'suName'
      }
      this.paramsList = {}
      this.time = []
      this.getList()
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList() {
      this.loadingTable = true
      this.list = []
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      queryPageAll(this.deliverState, this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 跳转供应商
    onSuName(row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter(time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 166px;
}
.number-wait {
  left: 270px;
}
.number-yetCreate {
  left: 358px;
}
</style>
